<template>
    <div class="cookies-content">
        <div class="content-message">
            <div class="content-message-text">
                {{ $t('cookie.text') }}
            </div>
            <div class="content-message-btn">
                <div class="content-message-btn-first" @click="openCookies">
                    <strong>{{ $t('cookie.leftBtn') }}</strong>
                </div>
                <div class="content-message-btn-two" @click="closeCookies">
                    <strong>{{ $t('cookie.rightBtnLeft') }}</strong>
                </div>
                <div class="content-message-btn-three" @click="closeCookies">
                    <strong>{{ $t('cookie.rightBtnRight') }}</strong>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    methods: {
        openCookies(){
            this.$emit('openCookies')
        },
        closeCookies(){
            this.$emit('closeTips')
        }
    }
}
</script>
<style scoped>
.cookies-content {
    width: 100%;
   
}

.content-message {
    background: #E7EAE2;
    width: 100%;
    padding: 20px 20px;
    position: fixed;
    bottom: 0;
    z-index: 10;
}

.content-message-btn {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.content-message-btn-first {
    width: 80%;
    height: 40px;
    text-align: center;
    border: black solid 1px;
    line-height: 40px;
    border-radius: 10px;
    margin-top: 10px;

}
/* .content-message-btn-first:hover {
	background-color: #555;
} */

.content-message-btn-first:active {
	background-color: #222;
    color: #ffffff;
}

.content-message-btn-two {
    background: black;
    width: 80%;
    height: 40px;
    text-align: center;
    border: black solid 1px;
    line-height: 40px;
    border-radius: 8px;
    color: white;
    margin-top: 10px;
}
.content-message-btn-two:active{
    background-color: #ffffff;
    color: #222;
}

.content-message-btn-three {
    background: black;
    width: 80%;
    height: 40px;
    text-align: center;
    border: black solid 1px;
    line-height: 40px;
    border-radius: 8px;
    color: white;
    margin-top: 10px;
}
.content-message-btn-three:active{
    background-color: #ffffff;
    color: #222;
}
</style>